'use client'
/**
 * These wallets do not fire events when switching accounts, so we should filter
 * them out of the wallet list if they are already linked to the user profile.
 */
const staticListToFilter = [
    'xverse',
    'magiceden',
    'magicedenbtc',
    'magicedensol',
];
/**
 * This function is a helper to filter out wallets that should not appear in the wallet list
 * if they are already linked to the user profile.
 */
const staticWalletFilter = (linkedWallets, walletOptions) => walletOptions.filter((walletOption) => {
    if (!staticListToFilter.includes(walletOption.key)) {
        return true;
    }
    if (linkedWallets.some((wallet) => wallet.connector.key === walletOption.key)) {
        return false;
    }
    return true;
});

export { staticWalletFilter };
